export default function () {
  this.sendEvent('close', {})
}
